import {EventDto} from "../../event-details/dtos";
import * as React from "react";
import {calendarBorderWidth, calendarCellHeight, calendarMinuteStep} from "../calendar-utils";
import {MOMENT_TIME_FORMAT} from "../../utils/date-utils";
import EventDetailsModal from "./EventDetailsModal";
import {Icon, Tag} from "antd";
import moment from "moment";
import {EventType} from "../../api/dtos/dtos";
import {renderEventTypeElement} from "../../client-calendar/EventType";

interface EventViewProps {
  event: EventDto;
  onEditClick: (event: EventDto) => void;
  onDeleteClick: (event: EventDto) => void;
}

interface EventViewState {
  showModal: boolean;
}

class EventView extends React.Component<EventViewProps, EventViewState> {

  constructor(props: EventViewProps) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  public render(): React.ReactNode {
    const {event, onEditClick, onDeleteClick} = this.props;
    const {client, contact, start, end} = event;
    const {showModal} = this.state;

    // calendar rows are by 30 minutes, here we calculate how many rows should this view overlap
    const heightMultiplier = end.diff(start, "minutes") / calendarMinuteStep;
    const dividerHeight = calendarBorderWidth * heightMultiplier;
    const fullHeight = (calendarCellHeight * heightMultiplier) + dividerHeight;
    const typeTodo = event.type === EventType.TODO ? " todo" : "";

    return (
      <div className="calendar-event-view-parent">
        <div
          className={"calendar-event-view" + typeTodo}
          style={{height: fullHeight, fontSize: "smaller"}}
          onClick={this.showModal}
        >
          {this.renderTitle()}
          {client && <span>{client?.name}</span>}
          {contact && <span>{contact?.name}</span>}
          {this.renderTimeRange(start, end)}
          {this.renderType()}
        </div>
        <EventDetailsModal
          event={event}
          show={showModal}
          onClose={this.closeModal}
          onEdit={onEditClick}
          onDelete={onDeleteClick}
        />
      </div>
    );
  }

  private renderTitle = (): React.ReactNode => {
    const {subject, alertHandled, alertDate, completed, hasAttachments} = this.props.event;
    return (
      <div style={{display: "flex"}}>
        <span style={{flex: 1}}><b>{subject}</b></span>
        {(alertDate !== undefined && !alertHandled) &&
            <Icon style={{marginTop: 3, marginLeft: 3}} type="bell"/>
        }
        {completed &&
            <Icon style={{marginTop: 3, marginLeft: 3}} type="check-circle" theme="twoTone" twoToneColor="#52c41a"/>
        }
        {hasAttachments &&
            <Icon style={{marginTop: 3, marginLeft: 3}} type="file-text"/>
        }
      </div>
    );
  }

  private renderType = (): React.ReactNode => {
    const {type} = this.props.event;
    switch (type) {
      case EventType.ONLINE_MEETING:
      case EventType.PERSONAL_MEETING:
        return <Tag style={{
          whiteSpace: "normal",
          display: "inline-block",
        }}>{renderEventTypeElement(type)}</Tag>
      case EventType.TODO:
        return <div/>;
    }
  }

  private renderTimeRange = (start: moment.Moment, end: moment.Moment): React.ReactNode => {
    return (
      <span style={{marginBottom: 4}}>{start.format(MOMENT_TIME_FORMAT)} - {end.format(MOMENT_TIME_FORMAT)}</span>
    );
  }

  private closeModal = () => {
    this.setState({
      showModal: false,
    });
  }

  private showModal = () => {
    this.setState({
      showModal: true,
    });
  }
}

export default EventView;


// WEBPACK FOOTER //
// ./src/event/view/EventView.tsx